var _rect, _rect2, _rect3, _rect4, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.875,
    y: 10.2812,
    width: 38.1875,
    height: 19.0938,
    fill: "#F9F871"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49.9375,
    y: 11.75,
    width: 38.1875,
    height: 48.4688,
    fill: "#FF6F91"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.875,
    y: 33.7812,
    width: 38.1875,
    height: 49.9375,
    fill: "#845EC2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 49.9375,
    y: 63.1562,
    width: 38.1875,
    height: 22.0312,
    fill: "#FF9671"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.75C0 10.1919 0.618972 8.69752 1.72075 7.59575C2.82252 6.49397 4.31685 5.875 5.875 5.875H88.125C89.6831 5.875 91.1775 6.49397 92.2793 7.59575C93.381 8.69752 94 10.1919 94 11.75V82.25C94 83.8081 93.381 85.3025 92.2793 86.4043C91.1775 87.506 89.6831 88.125 88.125 88.125H5.875C4.31685 88.125 2.82252 87.506 1.72075 86.4043C0.618972 85.3025 0 83.8081 0 82.25V11.75ZM49.9375 11.75V58.75H88.125V11.75H49.9375ZM49.9375 64.625V82.25H88.125V64.625H49.9375ZM44.0625 11.75H5.875V29.375H44.0625V11.75ZM5.875 82.25H44.0625V35.25H5.875V82.25Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.84add3a8ec5409765442f44b78d90552.svg";
export { ForwardRef as ReactComponent };